import { render, staticRenderFns } from "./Mar202023.vue?vue&type=template&id=14931610&scoped=true&"
import script from "./Mar202023.vue?vue&type=script&lang=js&"
export * from "./Mar202023.vue?vue&type=script&lang=js&"
import style0 from "./Mar202023.vue?vue&type=style&index=0&id=14931610&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14931610",
  null
  
)

export default component.exports